/*
    Copyright (C) 2023 - LMS2MTX - Southwest Airlines
*/
import React from "react";
import {
  getCodeVerifierFromAuthorizationRequest,
  OAuthBuilder,
} from "@ef/oauth-js-client";
import {
  ACCESS_TOKEN_KEY,
  AUTHORIZATION_OUTSTANDING_KEY,
  USER_ID,
} from "../Constants";
import { login } from "../../backend/auth/Login";
import { decodeToken } from "./Introspect";

class PingLogin extends React.Component {
  state = {
    error: null,
  };

  componentDidMount() {
    const oauth = new OAuthBuilder()
      .withFetchRequestor()
      .withNoHashQueryStringUtils()
      .withUsePkce(true)
      .build(
        process.env.REACT_APP_AUTH_CLIENT_ID,
        undefined,
        process.env.REACT_APP_AUTH_HOST
      );

    const setUserDetails = (token) => {
      sessionStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(token));
      try {
        sessionStorage.setItem(USER_ID, decodeToken(token).userId);
      } catch (error) {
        console.log(error);
      }
      console.log(token);
      login(token.accessToken)
        .then(() => {
          window.location.href = "/";
        })
        .catch((introspectError) => {
          this.setState({ error: introspectError });
        });
    };

    const authFlow = async () => {
      oauth.setAuthorizationListener(
        async (authRequest, authResponse, authError) => {
          if (authError) {
            this.setState({ error: authError });
          }
          if (authResponse) {
            try {
              await oauth.fetchAuthorizationServiceConfiguration();
              const codeVerifier =
                getCodeVerifierFromAuthorizationRequest(authRequest);
              const tokenResponse = await oauth.authorizationCodeExchange(
                authResponse.code,
                process.env.REACT_APP_REDIRECT_URI,
                codeVerifier,
                process.env.REACT_APP_AUD
              );
              setUserDetails(tokenResponse);
            } catch (tokenError) {
              this.setState({ error: tokenError });
            }
          }
        }
      );
      if (sessionStorage.getItem(AUTHORIZATION_OUTSTANDING_KEY) !== null) {
        sessionStorage.removeItem(AUTHORIZATION_OUTSTANDING_KEY);
        oauth.checkForAuthorizationResponse();
      } else {
        const authorize = async () => {
          await oauth.fetchAuthorizationServiceConfiguration();
          oauth.authorize(
            process.env.REACT_APP_REDIRECT_URI,
            process.env.REACT_APP_SCOPE
          );
        };
        sessionStorage.setItem(AUTHORIZATION_OUTSTANDING_KEY, "true");
        try {
          await authorize();
        } catch (authorizeError) {
          this.setState({ error: authorizeError });
        }
      }
    };

    authFlow();
  }

  render() {
    return (
      <div style={{ textAlign: "center", color: "var(--southwest-blue)" }}>
        {this.state.error ? (
          <div>
            <h1>
              {this.state.error}
              LMS Admin UI is currently unable to redirect to Ping. Please
              contact Service Desk for further assistance.
            </h1>
          </div>
        ) : (
          <h1>Loading...</h1>
        )}
      </div>
    );
  }
}

export default PingLogin;
